import { Component } from '@angular/core';

@Component({
    selector: 'app-invoicing-list',
    templateUrl: './invoicing-list.component.html',
    styleUrls: ['./invoicing-list.component.css']
})
export class InvoicingListComponent {
    // Cada panel carga sus propios datos en ngOnInit; el *ngIf de las pestañas
    // los crea y destruye, así que cambiar de pestaña refresca como antes.
    public activeTab: 'invoices' | 'receivable' = 'invoices';

    setTab(tab: 'invoices' | 'receivable') {
        this.activeTab = tab;
    }
}
